<app-dialog class="streetlight-efficiency-dialog">
  <ng-container dialog-title>
    {{ 'module.energyMap.streetlightEfficiencyPopup.popupTitle' | translate }}
  </ng-container>

  <ng-container dialog-content>
    <div class="overlay" *ngIf="isLoading">
      <span class="fa fa-spinner fa-spin fa-2x"></span>
    </div>

    <div class="chart-container">
      <app-line-gauge-chart-rainbow [dataRange]="range" [data]="chartData"></app-line-gauge-chart-rainbow>
    </div>

    <table class="table" aria-describedby="streetlight-efficiency">
      <tr>
        <th scope="col" class="legend-header label">{{ 'module.energyMap.streetlightEfficiencyPopup.legendHeaderText1' | translate }}</th>
        <th scope="col"></th>
        <th scope="col" class="legend-header label">{{ 'module.energyMap.streetlightEfficiencyPopup.legendHeaderText2' | translate }}</th>
      </tr>
      <tr>
        <td><img alt="marker-img" [src]="marker" /></td>
        <td class="legend-description">{{ 'module.energyMap.streetlightEfficiencyPopup.legendText1' | translate }}</td>
        <td class="legend-value">{{ efficiency?.lumenPerWattOptimized | number: '1.1-1' : 'es' }}</td>
      </tr>
      <tr *ngIf="data.isPlanner">
        <td><img alt="green-arrow-img" src="./assets/icons/arrow-green.svg" /></td>
        <td class="legend-description">{{ 'module.energyMap.streetlightEfficiencyPopup.legendText2' | translate }}</td>
        <td class="legend-value">{{ data.newEfficiency | number: '1.1-1' : 'es' }}</td>
      </tr>
      <tr>
        <td><img alt="light-grey-arrow-img" src="./assets/icons/arrow-light-grey.svg" /></td>
        <td class="legend-description">{{ 'module.energyMap.streetlightEfficiencyPopup.legendText3' | translate }}</td>
        <td class="legend-value">{{ efficiency?.lumenPerWattCurrent | number: '1.1-1' : 'es' }}</td>
      </tr>
      <tr>
        <td><img alt="dark-grey-arrow-img" src="./assets/icons/arrow-dark-grey.svg" /></td>
        <td class="legend-description">{{ 'module.energyMap.streetlightEfficiencyPopup.legendText4' | translate }}</td>
        <td class="legend-value">{{ averageEfficiency | number: '1.1-1' : 'es' }}</td>
      </tr>
    </table>

    <div class="footer">
      <div class="col1">{{ 'module.energyMap.streetlightEfficiencyPopup.legendText5' | translate }}</div>
      <div class="col2">{{ 'module.energyMap.streetlightEfficiencyPopup.legendText6' | translate }}</div>
      <div class="col3"></div>
    </div>
  </ng-container>
</app-dialog>
